import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
const dayjs = require("dayjs");

function Fee({ id, amount, fee, net, date }) {
  const formattedDate = dayjs(date * 1000);

  return (
    <Col className="payout-element" id={id}>
      <Row>
        <Col lg={3}>{dayjs(formattedDate).format("DD-MMM-YYYY")}</Col>
        <Col lg={3}>${amount.toLocaleString("en-US")}</Col>
        <Col lg={3}>${fee.toLocaleString("en-US")}</Col>
        <Col lg={3}>${net.toLocaleString("en-US")}</Col>
      </Row>
    </Col>
  );
}

export default Fee;
